/* Dias que quedan del drop de este mes.
 *
 * El drop sale el 1 y se baja el ultimo dia del mes, asi que "lo que queda"
 * son los dias hasta el 1 del mes siguiente. Este contador no inventa una
 * urgencia: la fecha de caducidad existe de verdad y el propio bloque de
 * "THE EXCLUSIVITY" de mas abajo ya la promete. Esto solo la hace visible.
 *
 * Se calcula con la fecha LOCAL del visitante, no la de la tienda. Un cliente
 * en otro huso puede ver un dia de diferencia en el cambio de mes, y es
 * preferible a la alternativa: si lo pintara Liquid con la hora de la tienda,
 * la pagina cacheada serviria un numero congelado del dia anterior, que es un
 * error mucho mas visible y mas frecuente.
 *
 * Se busca el elemento en cada pasada en vez de guardar una referencia, por lo
 * mismo que el contador del carrito: cualquier re-render del tema lo
 * destruiria y el contador se quedaria congelado.
 */
(function () {
  function pintar() {
    var el = document.querySelector('[data-sds-dropdays]');
    if (!el) return;

    var ahora = new Date();
    var hoy = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
    /* Dia 1 del mes siguiente. Pasar mes 12 a enero lo resuelve Date solo. */
    var proximo = new Date(ahora.getFullYear(), ahora.getMonth() + 1, 1);

    /* Math.round y no floor: con el cambio de hora un "dia" mide 23 o 25h y
       un floor se comeria una jornada entera una vez al ano. */
    var dias = Math.round((proximo - hoy) / 86400000);

    var texto;
    if (dias <= 1) {
      texto = 'LAST DAY';
    } else {
      texto = dias + ' DAYS LEFT';
    }

    if (el.textContent !== texto) el.textContent = texto;
    if (el.hidden) el.hidden = false;
  }

  pintar();
  document.addEventListener('DOMContentLoaded', pintar);
  /* Una vez por minuto basta: esto cambia una vez al dia, pero asi la cifra se
     corrige sola si alguien deja la pestana abierta toda la noche. */
  setInterval(pintar, 60000);
})();
